import PropTypes from 'prop-types';
// @mui
import { Box, Grid, Card, Paper, Typography, CardHeader, CardContent } from '@mui/material';
// utils
// import { fShortenNumber, fString } from '../../../../utils/formatNumber';
// _mock_


// ----------------------------------------------------------------------

export default function AnalyticsTrafficBySite() {
  return (
    <Card>
      <CardHeader title="Traffic by Site" />
      <CardContent>
        <Grid container spacing={2}>
          {[].map((site) => (
            <SiteItem key={site.name} site={site} />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

// ----------------------------------------------------------------------

SiteItem.propTypes = {
  site: PropTypes.shape({
    price: PropTypes.any,
    title: PropTypes.string,
    order: PropTypes.any,
  }),
};
export function formatAsINR(number) {
  if (isNaN(number)) {
    return "0";
}
  const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR'
  });
  let formattedNumber = formatter.format(number);
  return formattedNumber.replace(/\.00$/, '');
}
export function SiteItem({ title,order,price,hiddenprice }) {

  return (
  
      <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center',boxShadow:(theme)=>  theme.customShadows.z20, }}>
        {/* <Box sx={{ mb: 0.5 }}>{icon}</Box> */}
        <Typography variant="h4">{order}</Typography>
       {!hiddenprice &&<Typography variant="subtitle1">{formatAsINR(price)}</Typography>}
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {title}
        </Typography>
      </Paper>

  );
}
